<template>
  <div class="ImageContainer" :style="{'align-items': align, 'justify-content': justify}">

    <slot>
    </slot>

  </div>
</template>

<script>

//import component from '@assets/components/component.vue'

export default {
  name: 'ImageContainer',
  components: {
    //component
  },
  props: {
    justify: {type: String, default: 'space-around'},
    align: {type: String, default: 'center'}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.ImageContainer{
  text-align: center;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}

img{
}

</style>
